export function dataAtualFormatadaDDMMYYYY(date) {
  const data = new Date(date).toISOString().split('T')[0]
  const partes = data.split('-');
  return partes[2] + "/" + partes[1] + "/" + partes[0];
}

export function dataAtualFormatadaYYYYMMDD(date) {
  const data = new Date(date).toISOString().split('T')[0]
  const partes = data.split('-');
  return partes[0] + "-" + partes[1] + "-" + partes[2];
}



// export function dataAtualFormatadaDDMMYYYY2(date) {
//   var data = new Date(date),
//     dia = (data.getDate()).toString().padStart(2, '0'),
//     mes = (data.getMonth()).toString().padStart(2, '0'),
//     ano = data.getFullYear();
//   return dia + "/" + mes + "/" + ano;
// }
// export function dataAtualFormatadaDDMMYYYY3(date) {
//   var data = new Date(date),
//     dia = data.getDate().toString().padStart(2, '0'),
//     mes = (data.getMonth() + 1).toString().padStart(2, '0'),
//     ano = data.getFullYear();
//   return dia + "/" + mes + "/" + ano;
// }
